import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from '@tanstack/react-query';

import { createTopic, updateTopic } from '../../../../lib/redux/actions.jsx';
import {
  FormContainer,
  ButtonGroup,
  FormTitle,
  FormWrapper,
} from '../../../../shared/SettingsModal/StyledComponents';
import { Button } from '../../../../shared/FormStyles';
import TextInput from '../../../../shared/FormStyles/TextInput.jsx';
import { ColorsPicker } from '../../../../shared/SettingsModal/ColorsPicker.jsx';

const TopicForm = ({ item: topic, closeModal }) => {
  const { t } = useTranslation(['edit', 'shared']);
  const [name, setName] = useState('');
  const [color, setColor] = useState('');
  const disabled = !(name && color);
  const maxLengthName = 30;
  const charsLeft = maxLengthName - name?.length;
  const title = topic
    ? t('edit:topicForm:edit:title')
    : t('edit:topicForm:create:title');
  const label = t('edit:topicForm:label');
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (topic) {
      setName(topic.label || topic.name);
      setColor(topic.color);
    }
  }, [topic]);

  const submitForm = () => {
    const topicParams = {
      name,
      color,
      id: topic?.value,
    };

    if (topic) {
      dispatch(updateTopic(topicParams)).then(() =>
        queryClient.invalidateQueries(['boardSettings']),
      );
    } else {
      dispatch(createTopic(topicParams)).then(() =>
        queryClient.invalidateQueries(['boardSettings']),
      );
    }
    closeModal();
  };

  return (
    <FormWrapper>
      <FormTitle>{title}</FormTitle>
      <FormContainer>
        <div>
          <span className="character-counter">
            {t('edit:topicForm:characters_count', {
              characters_amount: charsLeft,
            })}
          </span>
          <TextInput
            label={label}
            placeholder={t('edit:topicForm:placeholder')}
            onChange={e => setName(e.target.value)}
            required="required"
            value={name}
            maxLength={25}
          />
        </div>
        <ColorsPicker
          color={color}
          resourceType="ribbon_tag"
          setColor={setColor}
        />
        <ButtonGroup>
          <Button variant="tertiary" onClick={() => closeModal()}>
            {t('shared:cancel')}
          </Button>
          <Button
            variant="containedBlue"
            ml="8px"
            type="submit"
            disabled={disabled}
            onClick={submitForm}
          >
            {t('shared:save')}
          </Button>
        </ButtonGroup>
      </FormContainer>
    </FormWrapper>
  );
};

export default TopicForm;
